
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.909 27.202c-1.32 0-2.4 1.065-2.4 2.39 0 1.314 1.07 2.389 2.4 2.389a2.389 2.389 0 100-4.779z"}}),_c('path',{attrs:{"d":"M52.406 28.586h-2.92c-.51-9.976-8.549-17.99-18.577-18.498V7.181a1 1 0 00-2 0v2.907c-10.018.508-18.067 8.512-18.577 18.498h-2.92a1 1 0 00-1 .995 1 1 0 001 .996h2.92c.51 9.976 8.549 17.99 18.577 18.498v2.907a1 1 0 002 0v-2.907c10.018-.508 18.067-8.512 18.577-18.498h2.92a1 1 0 001-.996 1 1 0 00-1-.995zM30.909 47.084v-8.95a1 1 0 00-2 0v8.95c-8.918-.498-16.067-7.626-16.577-16.507h8.988a1 1 0 001-.996 1 1 0 00-1-.995h-8.988c.5-8.88 7.659-15.999 16.577-16.507v8.95a1 1 0 002 0v-8.95c8.919.498 16.067 7.626 16.577 16.507h-8.988a1 1 0 00-1 .995 1 1 0 001 .996h8.988c-.5 8.88-7.658 16.009-16.577 16.507z"}})])
          )
        }
      }
    